export default __webpack_public_path__ + "static/media/mobile-user-guide.ef85be82.png";